import { Injectable, computed, inject } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { Store, select } from '@ngrx/store';
import { AppState } from '../store';
import { selectTenantInfo } from '../store/selectors';
import { checkIfPlatformSite } from '../common/platform-utils';

/**
 * Resolves which header/footer design to render. The revamped design is the
 * default for every tenant; a school owner can roll back to the classic design
 * via Admin => Settings => Navigation (tenant.useClassicHeaderFooter). The
 * platform site always stays classic.
 */
@Injectable({ providedIn: 'root' })
export class RevampDesignService {
  private readonly store = inject<Store<AppState>>(Store);

  private readonly isPlatformSite = checkIfPlatformSite();

  private readonly tenantSig = toSignal(this.store.pipe(select(selectTenantInfo)));

  readonly useNewDesign = computed(() => !this.isPlatformSite && !this.tenantSig()?.useClassicHeaderFooter);
}
